module.exports = __webpack_public_path__ + "images/146_2048.jpg";